'use strict';

const createErrorNotification = require('../components/errorNotification');

/**
 *
 * @param {*} responseJSON - Error object
 */
function handleErrorResponse(responseJSON) {
    if (responseJSON.errorType === 'ERROR_PASSWORD_MISMATCH') {
        let passwordInput = document.getElementById('login-form-password');
        passwordInput.classList.add('is-invalid');
        passwordInput.focus();
    }
    const errorNotificationElement = $('.error-messaging');
    if (responseJSON.errorMessage || responseJSON.customerErrorMessage) {
        let errorMessage = responseJSON.errorMessage || responseJSON.customerErrorMessage;
        createErrorNotification(errorNotificationElement, errorMessage);
    }

    if (responseJSON.errors && Array.isArray(responseJSON.errors)) {
        responseJSON.errors.forEach(error => {
            createErrorNotification(errorNotificationElement, error);
        });
    }

    if (responseJSON.fields && responseJSON.fields.dwfrm_coRegisteredCustomer_password) {
        let passwordInput = document.getElementById('login-form-password');
        passwordInput.classList.add('is-invalid');
        passwordInput.focus();
        createErrorNotification(errorNotificationElement, responseJSON.fields.dwfrm_coRegisteredCustomer_password);
    }
}

module.exports = {
    handleErrorResponse: handleErrorResponse
};
